import { AntimalwareAntiTamperingPanelWebComponent } from './component/AntimalwareAntiTamperingPanelWebComponent';
import { WEB_COMPONENT_ANTIMALWARE_ANTI_TAMPERING_PANEL } from '../../webcomponents.constants';

export { AntimalwareAntiTamperingPanelWebComponent };

window.customElements.define(
  WEB_COMPONENT_ANTIMALWARE_ANTI_TAMPERING_PANEL,
  AntimalwareAntiTamperingPanelWebComponent
);
